

const anteriorPaperDoll         = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_PaperDoll.png');
const anteriorAbdomen           = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Abdomen.png');
const anteriorChest             = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Chest.png');
const anteriorFace              = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Face.png');
const anteriorEars              = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Ears.png');
const anteriorNose              = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Nose.png');
const anteriorMouth              = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Mouth.png');
const anteriorEyes              = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Eyes.png');
const anteriorGenitals          = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Genitalia.png');
const anteriorHead              = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Head.png');
const anteriorLeftFoot          = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Left_Foot.png');
const anteriorLeftHand          = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Left_Hand.png');
const anteriorLowerLeftArm      = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_LowerLeft_Arm.png');
const anteriorLowerLeftLeg      = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_LowerLeft_Leg.png');
const anteriorLowerRightArm     = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_LowerRight_Arm.png');
const anteriorLowerRightLeg     = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_LowerRight_Leg.png');
const anteriorNeck              = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Neck.png');
const anteriorRightFoot         = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Right_Foot.png');
const anteriorRightHand         = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_Right_Hand.png');
const anteriorUpperLeftArm      = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_UpperLeft_Arm.png');
const anteriorUpperLeftLeg      = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_UpperLeft_Leg.png');
const anteriorUpperRightArm     = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_UpperRight_Arm.png');
const anteriorUpperRightLeg     = require('../assets/PaperDoll/Male_Anterior/Male_Anterior_UpperRight_Leg.png');

const posteriorPaperDoll        = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_PaperDoll.png');
const posteriorButtocks         = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_Buttocks.png');
const posteriorHead             = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_Head.png');
const posteriorLeftFoot         = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_Left_Foot.png');
const posteriorLeftHand         = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_Left_Hand.png');
const posteriorLowerBack        = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_Lower_Back.png');
const posteriorLowerLeftArm     = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_LowerLeft_Arm.png');
const posteriorLowerLeftLeg     = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_LowerLeft_Leg.png');
const posteriorLowerRightArm    = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_LowerRight_Arm.png');
const posteriorLowerRightLeg    = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_LowerRight_Leg.png');
const posteriorNeck             = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_Neck.png');
const posteriorRightFoot        = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_Right_Foot.png');
const posteriorRightHand        = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_Right_Hand.png');
const posteriorUpperBack        = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_Upper_Back.png');
const posteriorUpperLeftArm     = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_UpperLeft_Arm.png');
const posteriorUpperLeftLeg     = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_UpperLeft_Leg.png');
const posteriorUpperRightArm    = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_UpperRight_Arm.png');
const posteriorUpperRightLeg    = require('../assets/PaperDoll/Male_Posterior/Male_Posterior_UpperRight_Leg.png');


const anterior = {
  paperDoll: {
    styles: {
      width: '307px',
      height: '577px',
    },
    image: anteriorPaperDoll,
  },
  locations: {
    HEAD: {
      styles: {
        left: '133px',
        top: '2px',
        width: '39.3px',
      },
      tooltipPlacement: 'left',
      image: anteriorHead,
    },
    FACE: {
      styles: {
        left: '132px',
        top: '21.4px',
        width: '42px',
      },
      tooltipPlacement: 'left',
      image: anteriorFace,
      disableArrow: true,
    },
    NOSE: {
      styles: {
        left: '147px',
        top: '45px',
        width: '11px',
        zIndex: 2,
      },
      tooltipPlacement: 'left',
      image: anteriorNose,
      disableArrow: true,
      isDark: true,
    },
    MOUTH: {
      styles: {
        left: '145px',
        top: '55px',
        width: '16px',
        zIndex: 2,
        height: '15px',
      },
      tooltipPlacement: 'left',
      image: anteriorMouth,
      disableArrow: true,
      isDark: true,
    },
    EYES: {
      styles: {
        left: '136.5px',
        top: '27px',
        width: '34px',
        zIndex: 2,
      },
      tooltipPlacement: 'left',
      image: anteriorEyes,
      disableArrow: true,
      isDark: true,
    },
    EARS: {
      styles: {
        left: '128px',
        top: '35px',
        width: '50px',
      },
      tooltipPlacement: 'left',
      image: anteriorEars,
      disableArrow: true,
    },
    NECK: {
      styles: {
        left: '112.7px',
        top: '70.1px',
        width: '81.5px',
      },
      tooltipPlacement: 'left',
      image: anteriorNeck,
    },
    CHEST: {
      styles: {
        left: '103.1px',
        top: '100.1px',
        width: '101.1px',
      },
      tooltipPlacement: 'right',
      image: anteriorChest,
    },
    RIGHT_ARM_UPPER: {
      styles: {
        left: '60.8px',
        top: '96.2px',
        width: '62.7px',
      },
      tooltipPlacement: 'left',
      image: anteriorUpperRightArm,
    },
    RIGHT_ARM_LOWER: {
      styles: {
        left: '29.9px',
        top: '202.2px',
        width: '49.6px',
      },
      tooltipPlacement: 'left',
      image: anteriorLowerRightArm,
    },
    RIGHT_HAND: {
      styles: {
        left: '3.2px',
        top: '271.2px',
        width: '41.5px',
      },
      tooltipPlacement: 'left',
      image: anteriorRightHand,
    },
    LEFT_ARM_UPPER: {
      styles: {
        left: '183.9px',
        top: '96.1px',
        width: '62.3px',
      },
      tooltipPlacement: 'right',
      image: anteriorUpperLeftArm,
    },
    LEFT_ARM_LOWER: {
      styles: {
        left: '227.7px',
        top: '202.6px',
        width: '49.6px',
      },
      tooltipPlacement: 'right',
      image: anteriorLowerLeftArm,
    },
    LEFT_HAND: {
      styles: {
        left: '262.5px',
        top: '271.3px',
        width: '41.5px',
      },
      tooltipPlacement: 'right',
      image: anteriorLeftHand,
    },
    ABDOMEN: {
      styles: {
        left: '103.3px',
        top: '145.4px',
        width: '100.8px',
      },
      tooltipPlacement: 'right',
      image: anteriorAbdomen,
    },
    GENITALIA: {
      styles: {
        left: '99.6px',
        top: '245px',
        width: '107.9px',
      },
      tooltipPlacement: 'right',
      image: anteriorGenitals,
    },
    RIGHT_LEG_UPPER: {
      styles: {
        left: '100.8px',
        top: '336.1px',
        width: '46.8px',
      },
      tooltipPlacement: 'left',
      image: anteriorUpperRightLeg,
    },
    RIGHT_LEG_LOWER: {
      styles: {
        left: '101.1px',
        top: '427.7px',
        width: '31.9px',
      },
      tooltipPlacement: 'left',
      image: anteriorLowerRightLeg,
    },
    RIGHT_FOOT: {
      styles: {
        left: '103px',
        top: '540.6px',
        width: '28px',
      },
      tooltipPlacement: 'left',
      image: anteriorRightFoot,
    },
    LEFT_LEG_UPPER: {
      styles: {
        left: '159.7px',
        top: '336.1px',
        width: '46.7px',
      },
      tooltipPlacement: 'right',
      image: anteriorUpperLeftLeg,
    },
    LEFT_LEG_LOWER: {
      styles: {
        left: '174.3px',
        top: '427.7px',
        width: '31.8px',
      },
      tooltipPlacement: 'right',
      image: anteriorLowerLeftLeg,
    },
    LEFT_FOOT: {
      styles: {
        left: '176px',
        top: '541px',
        width: '28px',
      },
      tooltipPlacement: 'right',
      image: anteriorLeftFoot,
    },
  }
};

const posterior = {
  paperDoll: {
    styles: {
      width: '307px',
      height: '578px',
    },
    image: posteriorPaperDoll,
  },
  locations: {
    HEAD: {
      styles: {
        left: '128.6px',
        top: '3.1px',
        width: '50.2px',
      },
      tooltipPlacement: 'right',
      image: posteriorHead,
    },
    NECK: {
      styles: {
        left: '121.2px',
        top: '52.7px',
        width: '65.1px',
      },
      tooltipPlacement: 'right',
      image: posteriorNeck,
    },
    BACK_UPPER: {
      styles: {
        left: '71.5px',
        top: '89.1px',
        width: '164.3px',
      },
      tooltipPlacement: 'left',
      image: posteriorUpperBack,
    },
    RIGHT_ARM_UPPER: {
      styles: {
        left: '208.3px',
        top: '132.5px',
        width: '43.1px',
      },
      tooltipPlacement: 'right',
      image: posteriorUpperRightArm,
    },
    RIGHT_ARM_LOWER: {
      styles: {
        left: '231.8px',
        top: '206.2px',
        width: '49.6px',
      },
      tooltipPlacement: 'right',
      image: posteriorLowerRightArm,
    },
    RIGHT_HAND: {
      styles: {
        left: '266.6px',
        top: '277.1px',
        width: '37.3px',
      },
      tooltipPlacement: 'right',
      image: posteriorRightHand,
    },
    LEFT_ARM_UPPER: {
      styles: {
        left: '56.1px',
        top: '132.3px',
        width: '43.3px',
      },
      tooltipPlacement: 'left',
      image: posteriorUpperLeftArm,
    },
    LEFT_ARM_LOWER: {
      styles: {
        left: '25.7px',
        top: '206.1px',
        width: '50.1px',
      },
      tooltipPlacement: 'left',
      image: posteriorLowerLeftArm,
    },
    LEFT_HAND: {
      styles: {
        left: '3.3px',
        top: '277.1px',
        width: '37.2px',
      },
      tooltipPlacement: 'left',
      image: posteriorLeftHand,
    },
    BACK_LOWER: {
      styles: {
        left: '104px',
        top: '175.6px',
        width: '99px',
      },
      tooltipPlacement: 'left',
      image: posteriorLowerBack,
    },
    BUTTOCKS: {
      styles: {
        left: '97px',
        top: '234px',
        width: '113px',
      },
      tooltipPlacement: 'left',
      image: posteriorButtocks,
    },
    RIGHT_LEG_UPPER: {
      styles: {
        left: '160.3px',
        top: '341.2px',
        width: '48px',
      },
      tooltipPlacement: 'right',
      image: posteriorUpperRightLeg,
    },
    RIGHT_LEG_LOWER: {
      styles: {
        left: '174.3px',
        top: '437px',
        width: '35.1px',
      },
      tooltipPlacement: 'right',
      image: posteriorLowerRightLeg,
    },
    RIGHT_FOOT: {
      styles: {
        left: '180px',
        top: '549px',
        width: '26px',
      },
      tooltipPlacement: 'right',
      image: posteriorRightFoot,
    },
    LEFT_LEG_UPPER: {
      styles: {
        left: '98.5px',
        top: '341.2px',
        width: '48px',
      },
      tooltipPlacement: 'left',
      image: posteriorUpperLeftLeg,
    },
    LEFT_LEG_LOWER: {
      styles: {
        left: '98px',
        top: '437px',
        width: '35px',
      },
      tooltipPlacement: 'left',
      image: posteriorLowerLeftLeg,
    },
    LEFT_FOOT: {
      styles: {
        left: '101px',
        top: '548px',
        width: '27px',
      },
      tooltipPlacement: 'left',
      image: posteriorLeftFoot,
    },
  }
};

export default {
  anterior,
  posterior,
};

